import React, { useContext } from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../Context';
import { SecondaryActionBarContext } from '../../ActionBarContext';
import Flex from '../../../Flex';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import FluidMargin from './FluidMargin';
import { useDeviationAttributes } from '../../_partials/hooks/useDeviationAttributes';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import DeviationFlags from '../../buttons/DeviationFlags';
import CommentButton from '../../buttons/CommentButton';
import FavouriteButton from '../../buttons/FavouriteButton';
import AddToGroupButton from '../../buttons/AddToGroupButton';
import DownloadButton from '../../buttons/DownloadButton';
import PcpButton from '../../buttons/PcpButton';
import ShareButton from '../../buttons/ShareButton';
import MoreButton from '../../buttons/MoreButton';
import BuyButton from '../../buttons/BuyButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import TheaterButton from '../../buttons/TheaterButton';
import ExpandButton from '../../buttons/ExpandButton';
import s from './DesktopActionBar.scss';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import FreeAndPcpDownloadButton from '../../buttons/FreeAndPcpDownloadButton';
import { getDownloadButtonMode } from '../../buttons/FreeAndPcpDownloadButton/utils';
export var PrimaryDesktopActionBar = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, className = _a.className;
    var isTheater = useDeviationViewContext().isTheater;
    var setTopActionBarRef = useContext(SecondaryActionBarContext).setTopActionBarRef;
    var _b = useDeviationAttributes(deviation, isOwner), hasFlag = _b.hasFlag, isCommentable = _b.isCommentable, isDownloadable = _b.isDownloadable, isEditable = _b.isEditable, isDeletable = _b.isDeletable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, isPrintPurchasable = _b.isPrintPurchasable, isPurchasable = _b.isPurchasable, isReportable = _b.isReportable, isShareable = _b.isShareable;
    var isLiterature = getDeviationType(deviation) === DeviationTypes.LITERATURE;
    var shouldCombineFreeAndPcpDownload = useFlag('actionbar_phase_2');
    return (React.createElement(ActionBarStrip, { ref: setTopActionBarRef, className: classnames(s['root'], isTheater ? s['theater'] : s['normal-view'], isOwner && s['owner'], isLiterature && s['literature'], className) },
        React.createElement("div", { className: s['icons-wrapper'] },
            React.createElement("div", { className: s['badge'] }, hasFlag && (React.createElement(DeviationFlags, { deviation: deviation, disableLabel: isLiterature }))),
            React.createElement(FluidMargin, { index: 1 }),
            React.createElement("div", { className: s['icons-middle'] },
                React.createElement(Flex, { alignItems: "center" },
                    isFavouritable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(FavouriteButton, { deviation: deviation, actionBarType: "primary" }))),
                    isCommentable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner, actionBarType: "primary" })))),
                React.createElement(FluidMargin, { index: 4 }),
                React.createElement(Flex, { alignItems: "center" },
                    isGroupSubmittable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(AddToGroupButton, { deviation: deviation, actionBarType: "primary" }))),
                    isShareable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(ShareButton, { deviation: deviation }))),
                    isDownloadable && !shouldCombineFreeAndPcpDownload && (React.createElement("span", { className: s['icon'] },
                        React.createElement(DownloadButton, { deviation: deviation }))),
                    isPurchasable && !shouldCombineFreeAndPcpDownload && (React.createElement("span", { className: s['icon'] },
                        React.createElement(PcpButton, { isOwner: isOwner, deviation: deviation }))),
                    (isPurchasable || isDownloadable) &&
                        shouldCombineFreeAndPcpDownload && (React.createElement("span", { className: s['icon'] },
                        React.createElement(FreeAndPcpDownloadButton, { deviation: deviation, mode: getDownloadButtonMode({
                                isOwner: isOwner,
                                isDownloadable: isDownloadable,
                                isPurchasable: isPurchasable,
                            }) })))),
                (isPrintPurchasable ||
                    isReportable ||
                    isEditable ||
                    isDeletable) && React.createElement(FluidMargin, { index: 2 }),
                React.createElement(Flex, { alignItems: "center" },
                    isPrintPurchasable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(BuyButton, { deviation: deviation }))),
                    isReportable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(MoreButton, { deviation: deviation }))),
                    isDeletable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(DeleteButton, { deviation: deviation }))),
                    isEditable && (React.createElement("span", { className: s['icon'] },
                        React.createElement(EditButton, { deviation: deviation }))))),
            React.createElement(FluidMargin, { index: 3 }),
            React.createElement("div", { className: s['icons-right'] },
                React.createElement("span", { className: s['icon'] },
                    React.createElement(TheaterButton, { deviation: deviation })),
                React.createElement("span", { className: s['icon'] },
                    React.createElement(ExpandButton, { deviation: deviation }))))));
};
PrimaryDesktopActionBar.displayName = 'PrimaryDesktopActionBar';
export default PrimaryDesktopActionBar;
//# sourceMappingURL=PrimaryDesktopActionBar.js.map